import React, { Component, useEffect, useRef } from "react";
import { FcAcceptDatabase, FcAddImage, FcAdvertising, FcAudioFile, FcBusinessman, FcCalendar, FcCamcorderPro, FcClapperboard, FcCompactCamera, FcConferenceCall, FcDebt, FcList, FcMindMap, FcMoneyTransfer, FcNews, FcPortraitMode, FcPositiveDynamic, FcReading, FcReadingEbook, FcSalesPerformance } from "react-icons/fc";
import { ToastContainer } from "react-toastify";
import { FaBars, FaTimes, FaBell } from "react-icons/fa";
import 'react-toastify/dist/ReactToastify.css'
import CurrentUser from "../../libs/CurrentUser";
import SuggestFriends from "./SuggestFriends";
import MessagesPanel from "./MessagesPanel";
import { AiOutlineClose } from "react-icons/ai";


class FeedNav extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      sidebarOpen: false,
      filmMakersModalOpen: false
    };
  }

  componentDidMount() {
    // Listen for toggle events from Nav component
    window.addEventListener('toggleSidebar', this.handleToggleSidebar);
    window.addEventListener('closeSidebar', this.handleCloseSidebar);
  }

  componentDidUpdate(prevProps, prevState) {
    // Prevent body scroll when sidebar or modal opens/closes
    const sidebarStateChanged = this.state.sidebarOpen !== prevState.sidebarOpen;
    const modalStateChanged = this.state.filmMakersModalOpen !== prevState.filmMakersModalOpen;

    if (sidebarStateChanged || modalStateChanged) {
      const isOverlayOpen = this.state.sidebarOpen || this.state.filmMakersModalOpen;
      
      if (isOverlayOpen) {
        // Calculate scrollbar width to prevent layout shift
        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${scrollBarWidth}px`;
      } else {
        // Restore scroll and remove padding
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('toggleSidebar', this.handleToggleSidebar);
    window.removeEventListener('closeSidebar', this.handleCloseSidebar);
    // Restore body styles on unmount
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }

  handleToggleSidebar = () => {
    const newState = !this.state.sidebarOpen;
    this.setState({ sidebarOpen: newState });
    // Notify Nav of new state
    window.dispatchEvent(new CustomEvent('feedNavStateChange', { detail: { open: newState } }));
  }

  handleCloseSidebar = () => {
    this.setState({ sidebarOpen: false });
    window.dispatchEvent(new CustomEvent('feedNavStateChange', { detail: { open: false } }));
  }

  closeSidebar = () => {
    this.setState({ sidebarOpen: false });
    // Notify Nav that sidebar is closed
    window.dispatchEvent(new CustomEvent('feedNavStateChange', { detail: { open: false } }));
  }

  toggleFilmMakersModal = (e) => {
    e.preventDefault();
    this.setState(prevState => ({
      filmMakersModalOpen: !prevState.filmMakersModalOpen
    }));
  }

  closeFilmMakersModal = () => {
    this.setState({ filmMakersModalOpen: false });
  }

  render() {
    return (
      <React.Fragment>
        {/* Overlay - Only visible when sidebar is open on mobile */}
        {this.state.sidebarOpen && (
          <div className="feedNav-overlay" onClick={this.closeSidebar}></div>
        )}

        {/* Sidebar */}
        <div className={`feedNav-sidebar ${this.state.sidebarOpen ? 'open' : ''}`}>
          <div style={{ marginTop: "12px", marginLeft: "15px" }}>
            
          <a href="#" className="mt-3 d-md-none"
           onClick={(e) => {
    this.toggleFilmMakersModal(e);
    this.closeSidebar();
  }}
          // onClick={this.toggleFilmMakersModal}
          >
            <FcClapperboard className="news-feed-left-icon " />
            <span>Film Makers</span>
          </a>
          <a href="/" onClick={this.closeSidebar}>
            <FcAdvertising className="news-feed-left-icon" />
            <span>News Feed</span>
          </a>
          <a href="/notifications" onClick={this.closeSidebar}>
            <FaBell className="news-feed-left-icon" style={{ color: '#ff9500' }} />
            <span>Notifications</span>
          </a>
          <a href="/profile/0/edit" onClick={this.closeSidebar}>
            <FcPortraitMode className="news-feed-left-icon" />
            <span>Edit Profile</span>
          </a>
          <a href="/friends" onClick={this.closeSidebar}>
            <FcConferenceCall className="news-feed-left-icon" />
            <span>Friends</span>
          </a>
          <a href="/review-requests" onClick={this.closeSidebar}>
            <FcReadingEbook className="news-feed-left-icon" />
            <span>Review Requests</span>
          </a>

          <a href="/calendar" onClick={this.closeSidebar}>
            <FcCalendar className="news-feed-left-icon" />
            <span>Calendar/Availability</span>
          </a>

          <a href="/invites" onClick={this.closeSidebar}>
            <FcMindMap className="news-feed-left-icon" />
            <span>Send Invites</span>
            <span title="Invites Remaining" >
              {this.props.user?.invites_remaining}
            </span>
          </a>
          <a href="/companies" onClick={this.closeSidebar}>
            <FcBusinessman className="news-feed-left-icon" />
            <span>Company Profiles</span>
          </a>
          <a href="/profile/0/workhistory" onClick={this.closeSidebar}>
            <FcAcceptDatabase className="news-feed-left-icon" />
            <span>Work History</span>
          </a>
          <hr style={{ margin: '10px', width: '60%' }} />
          <a href="/seeking/crew" onClick={this.closeSidebar}>
            <FcReading className="news-feed-left-icon" />
            <span>Seeking Crew</span>
          </a>
          <a href="/seeking/work" onClick={this.closeSidebar}>
            <FcDebt className="news-feed-left-icon" />
            <span>Seeking Work</span>
          </a>
          <a href="/seeking/screenplay" onClick={this.closeSidebar}>
            <FcNews className="news-feed-left-icon" />
            <span>Seeking Screenplays</span>
          </a>
          <a href="/seeking/music" onClick={this.closeSidebar}>
            <FcAudioFile className="news-feed-left-icon" />
            <span>Seeking Music</span>
          </a>
          {/* <a href="/seeking/investment" >
            <FcMoneyTransfer className="news-feed-left-icon" />
            <span>Seeking Investment</span>
          </a> */}
          <hr style={{ margin: '10px', width: '60%' }} />
          {/* <a href="/film-market" >
            <FcClapperboard className="news-feed-left-icon" />
            <span>Film Market</span>
          </a>
          <hr style={{ margin: '10px', width: '60%' }} /> */}
          <a href="/watch-films" onClick={this.closeSidebar}>
            <FcCamcorderPro className="news-feed-left-icon" />
            <span>Watch Films</span>
          </a>
          <a href={`https://adminnew.gorillafilm.com/movie/add?token=${CurrentUser.token()}`} target="_blank" onClick={this.closeSidebar}>
            <FcAddImage className="news-feed-left-icon" />
            <span>Add Film</span>
          </a>
          <a href="/my-films" onClick={this.closeSidebar}>
            <FcCompactCamera className="news-feed-left-icon" />
            <span>My Favorite</span>
          </a>
          <a href="/my-list" onClick={this.closeSidebar}>
            <FcList className="news-feed-left-icon" />
            <span>My Films</span>
          </a>
          <br />
          <div className="button-wrapper">
          <a href="https://screnpla.com" target="_blank" className="screnpla-btn" onClick={this.closeSidebar}>
            <button
              type="button"
              // style={{ backgroundImage: 'linear-gradient(180deg,#ff9500,#ff5e3a)', color: 'white', borderRadius: '6px', fontSize: '12px', fontFamily: '"Arial", "Helvetica Neue"', fontWeight: '500', padding: '6px 12px', outline: 'none', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}
            className="modern-primary-button"
            >
              <b>SCRENPLA</b>
            </button>
          </a>
          <a href="https://filmfusefunder.com/" target="_blank" className="screnpla-btn" onClick={this.closeSidebar}>
            <button
              type="button"
             className="modern-primary-button"
            >
              <b>FILMFUSE FUNDER</b>
            </button>
          </a>
          </div>


          {/* <hr style={{ margin: '10px', width: '60%' }} />
          <a href="/buy-ads" >
            <FcSalesPerformance className="news-feed-left-icon" />
            <span>Buy Ads</span>
          </a>
          <a href="/my-ads" >
            <FcPositiveDynamic className="news-feed-left-icon" />
            <span>My Ads</span>
          </a> */}
          <ToastContainer />
          </div>
        </div>

        {/* Film Makers Modal */}
{this.state.filmMakersModalOpen && (
  <>
    {/* Modal Overlay */}
    <div 
      className="modal-backdrop fade show"
      onClick={this.closeFilmMakersModal}
      style={{ 
        zIndex: 9998,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }}
    ></div>

    {/* Modal Dialog */}
    <div 
      className="modal fade show d-block" 
      tabIndex="-1" 
      role="dialog"
      aria-modal="true"
      style={{ 
        position: 'fixed',
        zIndex: 9999,
        top: '30%',
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'clamp(10px, 5vw, 30px)',
        overflowY: 'auto',
        // height: '300px',
      }}
    >
      <div 
        className="modal-dialog modal-dialog-centered" 
        role="document" 
        style={{ 
          margin: 'auto',
          width: '100%',
          maxWidth: 'clamp(280px, 95vw, 900px)',
          maxHeight: 'clamp(300px, 90vh, 85vh)',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div className="modal-content film-modal-content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

          {/* Modal Header */}
          <div 
            className="modal-header" 
            style={{ 
              padding: 'clamp(12px, 3vw, 20px)',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexShrink: 0,
              gap: '10px'
            }}
          >
            <h5 
              className="modal-title" 
              style={{ 
                fontSize: 'clamp(14px, 3.5vw, 20px)',
                margin: 0,
                fontWeight: 600,
                flex: 1
              }}
            >
              Film Makers You Should Know
            </h5>
            <button 
              type="button" 
              className="btn-close"
              onClick={this.closeFilmMakersModal}
              style={{ 
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#6b7280',
                padding: '0',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          {/* Modal Body */}
          <div 
            className="modal-body"
            style={{ 
              flex: 1,
              padding: 'clamp(12px, 3vw, 24px)',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 'clamp(12px, 3vw, 20px)'
            }}
          >
            {/* Messages Panel */}
            <div style={{ width: '100%', minWidth: 0 }}>
              <MessagesPanel user={this.props.user} />
            </div>
            {/* Suggest Friends Panel */}
            <div style={{ width: '100%', minWidth: 0 }}>
              <SuggestFriends />
            </div>

          </div>

        </div>
      </div>
    </div>
  </>
)}
      </React.Fragment>
    );
  }
}

export default FeedNav;
